import $ from "jquery";
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
// You can use CoffeeScript in this file: http://jashkenas.github.com/coffee-script/

$(function() {
  
  if (($('#controller-admin').length === 0) && ($('#controller-users').length === 0)) { return; }
  
  if ($("#metrics_from").length !== 0) {
    $("#metrics_from").fdatepicker({format: 'yyyy-mm-dd'});
    $("#metrics_to").fdatepicker({format: 'yyyy-mm-dd'});
  }
  
});
